import { useState } from "react";
import { FileManagerDirectoryDto } from "../../interfaces";

interface FolderItemProps {
  item: FileManagerDirectoryDto;
  level?: number;
  parentPath?: string;
  onLeafClick: (fullPath: string) => void;
}
export const FolderItem: React.FC<FolderItemProps> = ({
  item,
  level = 0,
  parentPath = "",
  onLeafClick,
}) => {
  const [open, setOpen] = useState(true);
  const hasChildren = item.children && item.children.length > 0;

  const fullPath = parentPath ? `${parentPath}/${item.label}` : item.label;

  return (
    <li>
      <a
        href="#!"
        onClick={(e) => {
          e.preventDefault();

          if (hasChildren) {
            setOpen(!open);
          } else {
            onLeafClick(fullPath);
          }
        }}
        style={{ paddingLeft: `${level * 16}px` }}
        className="d-flex align-items-center"
      >
        <i
          className={`${
            hasChildren
              ? open
                ? "ri-folder-open-line"
                : "ri-folder-2-line"
              : "ri-folder-line"
          } me-2`}
        />
        <span className="file-list-link">{item.label}</span>
      </a>

      {hasChildren && open && (
        <ul className="sub-menu list-unstyled">
          {item.children!.map((child) => (
            <FolderItem
              key={child.id}
              item={child}
              level={level + 1}
              parentPath={fullPath} // 🔥 pass path down
              onLeafClick={onLeafClick}
            />
          ))}
        </ul>
      )}
    </li>
  );
};
